import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c39829fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "infinite-scroll-content" }
const _hoisted_2 = { class: "ion-padding" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, " Total quantity of articles across all scanned locations in this AS: ", -1))

import {
  IonPage,
  IonContent,
  IonItem,
  IonLabel,
  IonInfiniteScroll,
  IonTitle,
  IonToolbar,
  IonHeader,
  IonItemOption,
  IonCardHeader,
  IonCard,
  IonCardTitle,
  IonList,
} from '@ionic/vue';
import { useRoute, useRouter } from 'vue-router';
import useGetEntryCensusSheetDocuments from './_inner/useGetEntryCensusSheetDocuments';
import useAggregationPlacementModal from '@/composable/useAggregationPlacementModal';
import { BasicModal, BasicSpinner } from '@components/basic';
import BasicNormalInput from '@components/basic/form-elements/BasicNormalInput.vue';
import BasicEntryDocumentList from '@/components/basic/list/BasicEntryDocumentList.vue';
import BasicEntryModalContent from '@/components/basic/BasicEntryModalContent.vue';
import ArticleQuantityCardBase from '@/components/article/ArticleQuantityCardBase.vue';
import useDocumentApi from '@/composable/api/http/useDocumentApi';

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectStocktakingDocumentView',
  setup(__props) {

const router = useRouter();

const route = useRoute();
const id = Number(route.params.id);
const { loadMore, foundType, searchCode, documents, maxDocuments } =
  useGetEntryCensusSheetDocuments(id);
const {
  articlesModal,
  canLoadMoreItems,
  loadNextRows,
  articlesModalItems,
  storeEntriesData,
} = useAggregationPlacementModal(
  [
    'placementsRelatedForZD.product',
    'placementsRelatedForZD.combination',
    'placementsRelatedForZD.combination.product',
    'placementsRelatedForZD',
  ],
  8
);

const createNewASDocument = () => {
  const newAsDocument = createDocument(
    {
      type: 'AS',
      referenced_document_id: id,
    },
    {
      setNewAvailableCode: true,
      setNameBasedOnCode: true,
    }
  );
  newAsDocument
    .then((result) => {
      router.push({
        name: 'stocktaking/register-placements',
        params: { id: result.id },
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

const { createDocument } = useDocumentApi();

const handleShowProducts = async (documentId: number) => {
  return storeEntriesData(documentId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("WMS | Stocktaking")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(IonItem), {
              class: "ion-no-padding ion-margin-bottom",
              style: {"margin":"0 15px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Code: "),
                    _withDirectives(_createElementVNode("span", null, "(matched by: " + _toDisplayString(_unref(foundType)) + ")", 513), [
                      [_vShow, _unref(foundType)]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(BasicNormalInput, {
                  name: "code",
                  modelValue: _unref(searchCode),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchCode) ? (searchCode).value = $event : null))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonList), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (createNewASDocument()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCard), { class: "card__outer" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCardHeader), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCardTitle), null, {
                              default: _withCtx(() => [
                                _createTextVNode(" Create new AS document ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(BasicEntryDocumentList, {
              documents: _unref(documents),
              "show-document-creator": true,
              route: "stocktaking/register-placements"
            }, {
              default: _withCtx(({ document }) => [
                _createVNode(_unref(IonItemOption), {
                  color: "primary",
                  onClick: ($event: any) => (handleShowProducts(document.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Products ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["documents"]),
            _createVNode(_unref(IonInfiniteScroll), { onIonInfinite: _unref(loadMore) }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(BasicSpinner), { "is-loading": true })
                ], 512), [
                  [_vShow, _unref(documents).length < _unref(maxDocuments)]
                ])
              ]),
              _: 1
            }, 8, ["onIonInfinite"])
          ]),
          _createVNode(_unref(BasicModal), {
            modelValue: _unref(articlesModal).isOpen,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(articlesModal).isOpen) = $event))
          }, {
            title: _withCtx(() => [
              _createTextVNode(" Scanned products ")
            ]),
            default: _withCtx(() => [
              _createVNode(BasicEntryModalContent, {
                onLoadMoreItems: _unref(loadNextRows),
                "can-load-more": _unref(canLoadMoreItems),
                "is-loading": _unref(articlesModal).isLoading
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articlesModalItems), (article) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: article.document_product_id
                      }, [
                        _createVNode(ArticleQuantityCardBase, { article: article }, {
                          right: _withCtx(() => [
                            _createTextVNode(_toDisplayString(article.scanned_quantity) + " szt. ", 1)
                          ]),
                          _: 2
                        }, 1032, ["article"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["onLoadMoreItems", "can-load-more", "is-loading"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})